/**
 * Our podcast player controller
 */
angular.module('ffApp').controller('PodcastPlayerController', ['$scope', '$rootScope', '$resource', '$sce', '$element', function($scope, $rootScope, $resource, $sce, $element)
{
	$scope.playerOpen = $.cookie('playerOpen') == 'true'; // If cookie is set to 'true', player should be open
	$scope.volumeControllerOpen = false;
	$scope.podcastInfoLoaded = false;
	$scope.isPlaying = false;
	$scope.mediaLoaded = false;
	$scope.currentPlaybackTime = 0;

	$scope.player = $("#podcast-player");

	/**
	 * Trigger play/stop events globally
	 *
	 * @param event
	 */
	function triggerGlobalEvent(event)
	{
		if ( event == 'play' && typeof window.startPlay == 'function' )
		{
			window.startPlay();
		}

		if ( event == 'stop' && typeof window.stopPlay == 'function' )
		{
			window.stopPlay();
		}
	}

	/**
	 * Toggle player
	 */
	$scope.togglePlayer = function()
	{
		if ( $scope.playerOpen )
		{
			$scope.hidePlayer();
		}
		else
		{
			$scope.showPlayer();
		}
	};

	/**
	 * Show player
	 */
	$scope.showPlayer = function()
	{
		$scope.playerOpen = true;
		$.cookie('playerOpen', $scope.playerOpen, {expires: 7, path: '/'});

		//Dim content area
		jQuery('#page-wrap').find('.player-dim-content').removeClass('hidden').removeClass('transparent');

		//Disable menu while comments are open
		if( typeof navmenu == "object" )
		{
			navmenu.close();
			navmenu.hide();
		}

		//Make sure the podcast player and open/close button never end up outside the page
		if( jQuery( window ).height() < 667 ) {
			$element.css('position','absolute').css('bottom','auto').css('top','0');
			jQuery("html, body").animate({ scrollTop: "0px", easing: 'easeOutQuint' });
		}

		//Screen real-estate check
		setTimeout( function()
		{
			var space = jQuery('.podcast-player').offset().top - ( self.pageYOffset || document.documentElement.scrollTop  || document.body.scrollTop );
			if( space < 250 )
			{
				jQuery('.progress-holder').addClass('below');
				jQuery('.volume').addClass('below');
			}
			else
			{
				jQuery('.progress-holder').removeClass('below');
				jQuery('.volume').removeClass('below');
			}
		}, 600 );

		//Crop background content to avoid dimmed content scrolling
		var scrollPosition = [
			self.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft,
			self.pageYOffset || document.documentElement.scrollTop  || document.body.scrollTop
		];
		var html = jQuery('html'); // it would make more sense to apply this to body, but IE7 won't have that
		html.data('scroll-position', scrollPosition);
		html.data('previous-overflow', html.css('overflow'));
		html.css('overflow', 'hidden');
		window.scrollTo(scrollPosition[0], scrollPosition[1]);

	};

	/**
	 * Hide player
	 */
	$scope.hidePlayer = function()
	{
		$scope.playerOpen = false;
		$.cookie('playerOpen', $scope.playerOpen, {expires: 7, path: '/'});

		//Uncrop background content to re-enable content scrolling
		var html = jQuery('html');
		var scrollPosition = html.data('scroll-position') || [0,0];
		html.css('overflow', html.data('previous-overflow') || 'visible' );
		window.scrollTo(scrollPosition[0], scrollPosition[1]);

		//Dim content area
		jQuery('#page-wrap').find('.player-dim-content').addClass('transparent').delay(400).addClass('hidden');

		//Re-enable menu
		if( typeof navmenu == "object" ) {
			navmenu.show();
		}

		// Restore player css
		if( $element.css('position') == 'absolute' ) {
			$element.css('position','fixed').css('top','auto').css('bottom','0');
		}

		//Remove 'below' class regardless on close
		jQuery('.progress-holder').removeClass('below');
		jQuery('.volume').removeClass('below');
	};

	/**
	 * Get timeline position in percent
	 *
	 * @param seconds
	 * @returns {number}
	 */
	$scope.getTimelinePosition = function(seconds)
	{
		if ( $scope.currentEpisode.duration == 0 )
		{
			return 0;
		}

		return (parseFloat(seconds) / parseFloat($scope.currentEpisode.duration)) * 100;
	};

	/**
	 * Convert seconds to MM:SS
	 *
	 * @param seconds
	 * @returns {string}
	 */
	$scope.getNiceTime = function(seconds)
	{
		seconds = parseInt(seconds);

		var minutes = Math.floor(seconds / 60);
		seconds = seconds - (minutes * 60);

		if ( minutes < 10 )
		{
			minutes = '0' + minutes;
		}

		if ( seconds < 10 )
		{
			seconds = '0' + seconds;
		}

		return minutes + ':' + seconds;
	};

	/**
	 * Handle click on timeline
	 *
	 * @param event
	 */
	$scope.timelineClick = function(event)
	{
		$scope.playFromPosition = null;

		var mouseX;

		if ( ! $(event.target).hasClass('progress-holder') && ! $(event.target).hasClass('progressbar') )
		{
			return;
		}

		if ( event.offsetX == null ) // Firefox
		{
			mouseX = event.originalEvent.layerX;
		}
		else // Other browsers
		{
			mouseX = event.offsetX;
		}

		var width = $(event.currentTarget).width();
		var progressPercent = mouseX / width;

		$scope.play(progressPercent * $scope.currentEpisode.duration);
	};

	/**
	 * Set the volume
	 *
	 * @param volumePercent
	 */
	$scope.setVolume = function(volumePercent)
	{
		volumePercent = parseInt(volumePercent);

		volumePercent = Math.min(volumePercent, 100);
		volumePercent = Math.max(volumePercent, 0);

		$scope.player.jPlayer('volume', (volumePercent / 100));
		$scope.playerVolume = volumePercent;

		$.cookie('playerVolume', $scope.playerVolume, {expires: 7, path: '/'});
	};

	/**
	 * Handle click on volume bar
	 *
	 * @param event
	 */
	$scope.volumeClick = function(event)
	{
		var height = $(event.currentTarget).height();
		var mouseY;
		var offset = 0;

		if ( ! $(event.target).hasClass('volume-controller') && ! $(event.target).hasClass('progress') )
		{
			return;
		}

		if ( event.offsetY == null ) // Firefox
		{
			mouseY = event.originalEvent.layerY;
		}
		else // Other browsers
		{
			mouseY = event.offsetY;
		}

		if ( $(event.target).hasClass('progress') )
		{
			// Click is on .progress, so we'll need to adjust things a bit
			offset = height - $(event.target).height();
		}

		var invertedPercent = ((mouseY + offset) / height) * 100;
		var percent = 100 - invertedPercent;

		// Snap to max
		if ( percent > 95 )
		{
			percent = 100;
		}

		// Snap to min
		if ( percent < 5 )
		{
			percent = 0;
		}

		$scope.setVolume(percent);
	};

	/**
	 * Digest if it's not already in progress
	 */
	$scope.maybeDigest = function()
	{
		if ( ! $scope.$$phase )
		{
			$scope.$digest();
		}
	};

	/**
	 * Make a HTML string trusted
	 *
	 * @param html
	 * @returns {*}
	 */
	$scope.trustHtml = function(html)
	{
		return $sce.trustAsHtml(html);
	};

	/**
	 * Init player
	 */
	$scope.initPlayer = function()
	{
		// Main player
		$scope.player.jPlayer({
			ready: function(event)
			{
				$scope.player.trigger('ready');
				$scope.currentPlaybackTime = 0;

				// Set volume
				if ( typeof $.cookie('playerVolume') != 'undefined' )
				{
					$scope.setVolume($.cookie('playerVolume'));
				}
				else
				{
					// Default
					$scope.setVolume(75);
				}

				// Listen for playback progression
				$scope.player.bind($.jPlayer.event.timeupdate, function(event)
				{
					if ( Math.round(event.jPlayer.status.currentTime) != $scope.currentPlaybackTime )
					{
						$scope.currentPlaybackTime = Math.round(event.jPlayer.status.currentTime);

						$.cookie('podcast_' + $scope.currentEpisode.post_id, $scope.currentPlaybackTime, {expires: null, secure: false, path: '/'});

						$scope.maybeDigest();
					}
				});

				// Play event
				$scope.player.bind($.jPlayer.event.play, function()
				{
					$scope.isPlaying = true;
					triggerGlobalEvent('play');

					// Maybe record stats
					if ( $.cookie('wasPlaying') != 'true' )
					{
						ga('send', 'event', 'Podcast', 'Play', $scope.currentEpisode.title);
					}

					$.cookie('wasPlaying', true, {expires: null, secure: false, path: '/'});
				});

				// Pause event
				$scope.player.bind($.jPlayer.event.pause, function()
				{
					$scope.isPlaying = false;
					triggerGlobalEvent('stop');

					$.cookie('wasPlaying', false, {expires: null, secure: false, path: '/'});
				});

				// Resume playback?
				$scope.playFromPosition = null;

				if ( typeof $.cookie('podcast_' + $scope.currentEpisode.post_id) != 'undefined' )
				{
					$scope.playFromPosition = $.cookie('podcast_' + $scope.currentEpisode.post_id);
				}

				// Autostart playback?
				if ( $.cookie('wasPlaying') == 'true' )
				{
					$scope.play();
				}

				// Set episode duration
				$scope.player.bind($.jPlayer.event.loadeddata, function()
				{
					$scope.currentEpisode.duration = $scope.player.data('jPlayer').status.duration;
				});
			},

			error: function(event)
			{
				$scope.player.trigger('error', [event]);
			},

			swfPath: templateDirectoryUrl + "/js/lib/",
			solution: "html, flash",
			supplied: "mp3",
			preload: "metadata"
		});
	};

	/**
	 * Load media if not already loaded
	 */
	$scope.loadMedia = function()
	{
		if ( ! $scope.mediaLoaded )
		{
			$scope.player.jPlayer('setMedia', { mp3: $scope.currentEpisode.url } );
			$scope.mediaLoaded = true;
		}
	};

	/**
	 * Start playback
	 *
	 * @param position
	 */
	$scope.play = function(position)
	{
		$scope.loadMedia();


		// Play from position
		if ( typeof(position) !== 'undefined')
		{
			$scope.player.jPlayer('play', parseInt(position));
		}
		else if ( $scope.playFromPosition != null )
		{
			$scope.player.jPlayer('play', parseInt($scope.playFromPosition));
			$scope.playFromPosition = null;
		}
		else
		{
			$scope.player.jPlayer('play');
		}

		$.cookie('lastPlayedEpisodeId', $scope.currentEpisode.post_id, {expires: null, secure: false, path: '/'});

		//socket.emit('play start', ((typeof window.inviteCode === 'undefined')?"":window.inviteCode));

		$scope.isPlaying = true;
	};

	/**
	 * Pause
	 */
	$scope.pause = function(position)
	{
		if ( typeof(position) !== 'undefined')
		{
			$scope.loadMedia();
			$scope.player.jPlayer('pause', parseInt(position));
		}
		else
		{
			$scope.player.jPlayer('pause');
		}

		//socket.emit('play stop', '');

		$scope.isPlaying = false;
	};

	/**
	 * Toggle playback
	 */
	$scope.togglePlayback = function()
	{
		if ( $scope.isPlaying )
		{
			$scope.pause();
		}
		else
		{
			$scope.play();
		}
	};

	/**
	 * Play previous episode
	 */
	$scope.previous = function()
	{
		$scope.pause();
		$scope.mediaLoaded = false;

		var resource = $resource('/api/podcast/' + $scope.currentEpisode.post_id + '/previous');

		$scope.currentEpisode = resource.get(function(podcast)
		{
			$.cookie('lastPlayedEpisodeId', $scope.currentEpisode.post_id, {expires: null, secure: false, path: '/'});

			if ($scope.isPlaying)
			{
				$scope.play();
			}
		});
	};

	/**
	 * Play next episode
	 */
	$scope.next = function()
	{
		$scope.pause();
		$scope.mediaLoaded = false;

		var resource = $resource('/api/podcast/' + $scope.currentEpisode.post_id + '/next');

		$scope.currentEpisode = resource.get(function(podcast)
		{
			$.cookie('lastPlayedEpisodeId', $scope.currentEpisode.post_id, {expires: null, secure: false, path: '/'});

			if ($scope.isPlaying)
			{
				$scope.play();
			}
		});
	};

	/**
	 * Load default episode
	 */
	$scope.loadDefaultEpisode = function()
	{
		var resource;

		// Load default episode
		if ( typeof $.cookie('lastPlayedEpisodeId') != 'undefined' )
		{
			resource = $resource('/api/podcast/' + $.cookie('lastPlayedEpisodeId'));
		}
		else
		{
			resource = $resource('/api/podcast');
		}

		$scope.currentEpisode = resource.get(function(podcast)
		{
			if (podcast.error == true && typeof $.cookie('lastPlayedEpisodeId') != 'undefined')
			{
				// We probably have a cookie with invalid content, let's remove it and try again
				$.cookie('lastPlayedEpisodeId', null, {expires: null, secure: false, path: '/'});
				$scope.loadDefaultEpisode();
			}
			else
			{
				$scope.podcastInfoLoaded = true;
				$scope.initPlayer();
			}
		});
	};
	$scope.loadDefaultEpisode();

	// Handle play events
	$rootScope.$on('playPodcast', function(event, postId)
	{
		$scope.pause();
		$scope.mediaLoaded = false;

		var resource = $resource('/api/podcast/' + postId);

		$scope.currentEpisode = resource.get(function(podcast)
		{
			$.cookie('lastPlayedEpisodeId', $scope.currentEpisode.post_id, {expires: null, secure: false, path: '/'});

			$scope.play();
		});
	});

	// Explicitly run the show or hide method
	if ( $scope.playerOpen )
	{
		$scope.showPlayer();
	}
	else
	{
		$scope.hidePlayer();
	}

	/**
	 * Calculate pointer position when hovering timeline
	 *
	 * @param event
	 */
	$scope.hoverTimeline = function(event)
	{
		var width = $(event.currentTarget).width();
		var position = event.clientX - $(event.currentTarget).offset().left;

		position = Math.max(position, 0);
		position = Math.min(position, width);

		$scope.timeselectionPosition = (position) / width;
	};

	$scope.reloadPodcastData = function()
	{
		var resource = $resource('/api/podcast/' + $scope.currentEpisode.post_id);

		resource.get(function(episode)
		{
			$scope.currentEpisode = episode;
		});
	};
}]);